import React, { useEffect, useState } from "react";

import callIcon from "../../../assets/img/icons/call-2.svg";
import deleteIcon from "../../../assets/img/icons/delete3.svg";
import locationIcon from "../../../assets/img/icons/location_icon.svg";
import BackButtonComponent from "../../../components/BackButtonComponent/BackButtonComponent";
import ToggleButtonComponent from "../../../components/ToggleButton/ToggleButton";
import {
  BorderButtonWithIcon,
  ColoredButton,
  PrimaryWhiteBgButton,
  WhiteButtonWithIcon,
} from "../../../styledComponents/buttons";
import {
  CommonFlex,
  CommonGrid,
  CommonImage,
  CommonText,
  Container,
  ContainerNew,
  ContentHeader,
  InputWithLabelSection,
  PageTitle,
} from "../../../styledComponents/common";
import { CommImageNameComp } from "../../Members/CommonComponents";
import DeleteModal from "../CommonComponents/DeleteModal";
import { WorkflowsSection } from "../Setup/IntegrationSetup";
import { IntegrationNameContainer } from "../Setup/integrationSetupStyles";
import MemberRightSidePanel from "./MemberRightSidePanel";

const GustoSettings = ({
  history,
  location,
  selectedOrganization,

  isLoadingFeatures,
  integration,
  featuresList,
  featuresLoading,

  getFeatures,
  updateFeatures,

  getCompanyDetails,
  deleteIntegration,
  getEmployeeList,
  updateCompanyLogo,
  employeeList,
  employeeLoading,
  companyDetails,
  companyLoading,
  bulkInvite,
  bulkInviteLoading,
  deleteLoading,

  // members invited list
  memberInvitedList,
  memberInvitedCount,
  getInvitedList,
}) => {
  const [timesheetSync, setTimesheetSync] = useState(false);
  const [isMemberPanelOpen, setIsMemberPanelOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [loadFirstTime, setLoadFirstTime] = useState(true);

  useEffect(() => {
    if (featuresList && loadFirstTime) {
      const timesheetFeature = featuresList.find(
        feature => feature.feature_name === "timesheet",
      );
      if (timesheetFeature) {
        setTimesheetSync(timesheetFeature.fieldservicely_update);
        setLoadFirstTime(false);
      }
    }
  }, [featuresList]);

  useEffect(() => {
    if (selectedOrganization?.id) {
      const payload = {
        organization_id: selectedOrganization.id,

        // integration features
        name: "Gusto",
      };

      getFeatures(payload);
      getCompanyDetails(payload);
      getEmployeeList(payload);
      getInvitedList(payload);
    }
  }, [selectedOrganization]);

  const handleInviteClick = employee => {
    // Implement the logic to invite the employee here
    console.log("Invite clicked for employee:", employee);
    const payload = {
      organization_id: selectedOrganization.id,
      employees: employee,
    };
    console.log("payload", payload);
    bulkInvite(payload);
    getInvitedList(payload);
  };

  const handleDelete = () => {
    const payload = {
      organization_id: selectedOrganization.id,
      company_id: companyDetails?.id,
    };

    setTimeout(() => {
      setIsDeleteModalOpen(false);
      deleteIntegration(payload);
      history.push("/user/integrations");
    }, 500);
  };

  const handleSyncToggle = () => {
    setTimesheetSync(prev => !prev);
    // Find the timesheet feature from featuresList
    const timesheetFeature = featuresList?.find(
      feature => feature.feature_name === "timesheet",
    );

    if (!timesheetFeature) {
      console.error("Timesheet feature not found in featuresList");
      return;
    }

    // Use the mapper to create the payload - webhook toggles between true/false
    const payload = {
      organization_id: selectedOrganization.id,
      name: "Gusto",
      id: timesheetFeature.id,
      feature_name: "timesheet",
      fieldservicely_update: !timesheetSync, 
      fieldservicely_create: !timesheetSync, 
      fieldservicely_delete: !timesheetSync, 
    }

    updateFeatures(payload);
  };

  return (
    <div className="content">
      <MemberRightSidePanel
        isOpen={isMemberPanelOpen}
        toggle={() => setIsMemberPanelOpen(!isMemberPanelOpen)}
        isLoading={employeeLoading}
        listItems={employeeList}
        handleClick={handleInviteClick}
        memberInvitedList={memberInvitedList}
      />
      <DeleteModal
        isOpen={isDeleteModalOpen}
        toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}
        handleDelete={() => handleDelete()}
        deleteIsLoading={deleteLoading}
      />
      <BackButtonComponent
        subTitle="Back to all integrations"
        onClick={() => history.push("/user/integrations")}
      />
      <ContainerNew>
        <Container showBorder={true} gap="32px" padding="20px">
          {/* Top Section */}
          <CommonGrid>
            {/* Left Section */}
            <CommonGrid columns="1fr" gap="8px">
              <CommonText name bold fontSize="24px">
                {companyDetails?.name || "Gusto Integration"}
              </CommonText>

              {companyDetails?.location && (
                <CommonFlex gap="4px">
                  <CommonImage
                    src={locationIcon}
                    alt="Location Icon"
                    width="16px"
                    height="16px"
                  />
                  <CommonText fontSize="14px" marginLeft="5px">
                    {companyDetails?.location}
                  </CommonText>
                </CommonFlex>
              )}

              {companyDetails?.phone && (
                <CommonFlex gap="4px">
                  <CommonImage
                    src={callIcon}
                    alt="Call Icon"
                    width="16px"
                    height="16px"
                  />
                  <CommonText fontSize="14px" marginLeft="5px">
                    {companyDetails?.phone}
                  </CommonText>
                </CommonFlex>
              )}
            </CommonGrid>

            {/* Right Section */}
            <CommonFlex gap="8px">
              <PrimaryWhiteBgButton
                marginTop="0"
                onClick={() => setIsMemberPanelOpen(true)}
              >
                Employee Sync
              </PrimaryWhiteBgButton>
              {/* <PrimaryWhiteBgButton marginTop="0">
                Payroll Sync
              </PrimaryWhiteBgButton> */}
              <BorderButtonWithIcon
                hoverBgColor="#FECDB4"
                columns="1fr"
                padding="10px"
                borderRadius="32px"
                borderColor="#FECDB4"
                onClick={() => setIsDeleteModalOpen(true)}
              >
                <CommonImage
                  src={deleteIcon}
                  alt="Delete Icon"
                  width="20px"
                  height="20px"
                />
              </BorderButtonWithIcon>
            </CommonFlex>
          </CommonGrid>

          {/* Bottom Section */}
          <CommonGrid>
            {companyDetails?.primary_signatory ? (
              <InputWithLabelSection>
                <CommonText>Primary Signatory</CommonText>
                <CommImageNameComp
                  size="40px"
                  fontSize="14px"
                  name={`${companyDetails.primary_signatory.first_name} ${
                    companyDetails.primary_signatory.last_name || ""
                  }`}
                  email={companyDetails.primary_signatory?.email}
                  columnGap="8px"
                />
              </InputWithLabelSection>
            ) : (
              <div />
            )}

            <CommonFlex gap="8px" alignItems="center">
              <CommonText>Timesheet Sync</CommonText>
              <ToggleButtonComponent
                active={timesheetSync}
                handleClick={handleSyncToggle}
                width="32px"
                height="18px"
                circleSize="10px"
              />
            </CommonFlex>
          </CommonGrid>
        </Container>
      </ContainerNew>
    </div>
  );
};

export default GustoSettings;
